module.exports = __webpack_public_path__ + "static/media/banner-slide-dark.83a5c297.png";